import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav(loc.state?.from?.pathname || "/jobs", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  const googleLogin = () => {
    const redirect = `${window.location.origin}/auth/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md nb-card p-8" data-testid="login-card">
        <div className="label-eyebrow mb-2">Welcome back</div>
        <h1 className="text-4xl font-black tracking-tight">Log in</h1>
        <p className="text-gray-600 mt-2 text-sm">Continue your remote job hunt.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-widest">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full border-2 border-black rounded-lg px-3 py-2.5 outline-none focus:ring-2 focus:ring-[#4338ca]" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-widest">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full border-2 border-black rounded-lg px-3 py-2.5 outline-none focus:ring-2 focus:ring-[#4338ca]" />
          </div>
          <button data-testid="login-submit" type="submit" disabled={busy}
            className="nb-btn bg-[#4338ca] text-white w-full py-3">{busy ? "Signing in…" : "Sign in"}</button>
        </form>

        <div className="my-6 flex items-center gap-3 text-xs text-gray-500 font-bold uppercase tracking-widest">
          <div className="flex-1 h-px bg-black" /> OR <div className="flex-1 h-px bg-black" />
        </div>

        <button data-testid="login-google" onClick={googleLogin} className="nb-btn bg-white w-full py-3 flex items-center justify-center gap-2">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Continue with Google
        </button>

        <p className="mt-6 text-sm text-center text-gray-600">
          Don't have an account? <Link to="/signup" data-testid="to-signup" className="font-bold text-[#4338ca] underline">Sign up</Link>
        </p>
      </div>
    </div>
  );
}
